export default __webpack_public_path__ + "static/media/check-mark.6121af65.svg";